import Api from "./base/api-base";

export default class ClientMasterApi {
  list() {
    return Api.get({
      endpoint: Api.endpoint.client
    });
  }

  store (params) {
    return Api.post({
      endpoint: Api.endpoint.client,
      params: params
    });
  }

  info (id) {
    return Api.get({
      endpoint: Api.endpoint.client,
      id: id
    });
  }

  update (id, params) {
    return Api.post({
      endpoint: Api.endpoint.client,
      id: id,
      params: params
    });
  }

  delete(id) {
    return Api.delete({
      endpoint: Api.endpoint.client,
      id: id
    });
  }
}